// ======================================================================
// File: IndentItemTable.jsx
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Display indent line items
// - Allow edit/delete only in DRAFT
//
// ======================================================================

import { formatQuantity } from "../../../../../../utils/formatUtils";
import React, { useState } from "react";

import indentService from "../services/indentService";
import INDENT_STATUS from "../enums/indentStatus";

import IndentItemDrawer from "../form/IndentItemDrawer";

export default function IndentItemTable({
  items = [],
  status,
  canEdit,
  onRefresh,
}) {
  const [editItem, setEditItem] = useState(null);

  //const editable = status === INDENT_STATUS.DRAFT;
  const editable =
  canEdit &&
  status === INDENT_STATUS.DRAFT;
  
  const handleDelete = async (lineId) => {
    if (
      !window.confirm(
        "Delete this indent item?"
      )
    )
      return;

    await indentService.deleteIndentLine(
      lineId
    );
    onRefresh();
  };

  return (
    <div className="erp-table-wrapper">

      <table className="erp-table">
        <thead>
          <tr>
            <th>Material Type</th>
            <th>Material</th>
            <th>UOM</th>
            <th>Required Qty</th>
            <th>Approved Qty</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {items.length === 0 && (
            <tr>
              <td colSpan={6}>
                No items added
              </td>
            </tr>
          )}

          {items.map((row) => (
            <tr key={row.id}>
              <td>{row.material_type}</td>
              <td>{row.material_name}</td>
              <td>{row.uom_code || row.uom}</td>
              <td>{formatQuantity(row.required_qty)}</td>
              <td>
                <td>
                {row.approved_qty != null
                  ? formatQuantity(row.approved_qty)
                  : "-"}
              </td>
              </td>

              <td>
                {editable && (
                  <>
                    <button
                      className="btn-link"
                      onClick={() =>
                        setEditItem(row)
                      }
                    >
                      Edit
                    </button>

                    <button
                      className="btn-link danger"
                      onClick={() =>
                        handleDelete(row.id)
                      }
                    >
                      Delete
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* EDIT DRAWER */}
      {editItem && (
        <IndentItemDrawer
          open={true}
          indentId={
            editItem.indent_id ||
            editItem.indentId
          }
          record={editItem}
          onClose={() => setEditItem(null)}
          onSaved={() => {
            setEditItem(null);
            onRefresh();
          }}
        />
      )}
    </div>
  );
}
